module.exports = __webpack_public_path__ + "static/media/product-manufacturing-mobile-2.855a367e.png";